import type {
  ImportFailureReason,
  InviteClaimFailureReason,
  PlanFailureReason,
} from "@batch-and-bowl/shared";
import { ApiError } from "./api/client";

export type AnalyticsFailureDomain = "plan" | "import" | "invite";

export function analyticsFailure(
  error: unknown,
  domain: "plan",
): { status: number; reason: PlanFailureReason };
export function analyticsFailure(
  error: unknown,
  domain: "import",
): { status: number; reason: ImportFailureReason };
export function analyticsFailure(
  error: unknown,
  domain: "invite",
): { status: number; reason: InviteClaimFailureReason };
export function analyticsFailure(
  error: unknown,
  domain: AnalyticsFailureDomain,
): { status: number; reason: PlanFailureReason | ImportFailureReason | InviteClaimFailureReason } {
  const status = error instanceof ApiError ? error.status : 0;
  const code =
    error instanceof ApiError &&
    error.data !== null &&
    typeof error.data === "object" &&
    "code" in error.data &&
    typeof error.data.code === "string"
      ? error.data.code
      : undefined;

  if (domain === "import") {
    const reason: ImportFailureReason =
      code === "UNSUPPORTED_PAGE"
        ? "unsupported_page"
        : code === "EXTRACTION_FAILED"
          ? "extraction_failed"
          : code === "RATE_LIMITED" || status === 429
            ? "rate_limited"
            : status === 0
              ? "network_error"
              : status >= 500 && status <= 599
                ? "server_error"
                : "unknown";
    return { status, reason };
  }

  if (domain === "invite") {
    const reason: InviteClaimFailureReason =
      code === "invalid_code"
        ? "invalid_code"
        : code === "already_used"
          ? "already_used"
          : code === "beta_full"
            ? "beta_full"
            : code === "rate_limited" || status === 429
              ? "rate_limited"
              : status === 0
                ? "network_error"
                : status >= 500 && status <= 599
                  ? "server_error"
                  : "unknown";
    return { status, reason };
  }

  const reason: PlanFailureReason =
    status === 400
      ? "validation_failed"
      : status === 401
        ? "unauthorized"
        : status === 409
          ? "conflict"
          : status === 0
            ? "network_error"
            : status >= 500 && status <= 599
              ? "server_error"
              : "unknown";
  return { status, reason };
}
